import { SceneManager } from './core/SceneManager';
import { AnimationController } from './core/AnimationController';
import { Icosahedron } from './objects/Icosahedron';

// Facade pattern for easy application management
export class VectorLabApp {
    private sceneManager: SceneManager;
    private animationController: AnimationController;
    private icosahedron: Icosahedron;

    constructor() {
        this.sceneManager = SceneManager.getInstance();
        this.animationController = new AnimationController();
        this.icosahedron = new Icosahedron();
    }

    public init(): void {
        this.setupScene();
        this.setupEventListeners();
        this.start();
    }

    private setupScene(): void {
        this.animationController.addObject(this.icosahedron);
    }

    private setupEventListeners(): void {
        window.addEventListener('resize', () => {
            this.sceneManager.resize();
        });

        document.addEventListener('visibilitychange', () => {
            if (document.hidden) {
                this.animationController.stop();
            } else {
                this.animationController.start();
            }
        });
    }

    private start(): void {
        this.animationController.start();
    }

    public destroy(): void {
        this.animationController.destroy();
        window.removeEventListener('resize', () => {
            this.sceneManager.resize();
        });
    }
}
